import { createAction, props } from '@ngrx/store';

import { SalesOrderPeriod } from '../models/sales-order-period.models';

export const setSalesOrderPeriods = createAction(
  '[Sales order period] Set sales order periods',
  props<{ salesOrderPeriods: SalesOrderPeriod[] }>(),
);
